var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_4575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#26A69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.5H7.5V9H16.5V6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5C9.7715 10.5 6 10.8685 6 12.25C6 13.6315 9.7715 14 12 14C14.2285 14 18 13.6315 18 12.25C18 10.8685 14.2285 10.5 12 10.5ZM12 13C9.2385 13 7 12.5525 7 12C7 11.4475 9.2385 11 12 11C14.7615 11 17 11.4475 17 12C17 12.5525 14.7615 13 12 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12.5475 12 13.0465 11.9815 13.5 11.951V6.5H10.5V11.951C10.9535 11.9815 11.4525 12 12 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8615 12.9831C12.806 12.9851 12.75 12.9866 12.6935 12.9881C12.466 12.9946 12.236 12.9991 12 12.9991C11.764 12.9991 11.534 12.9946 11.3065 12.9886C11.25 12.9871 11.194 12.9856 11.1385 12.9836C10.921 12.9761 10.707 12.9666 10.5 12.9536V17.9991H13.5V12.9531C13.293 12.9661 13.079 12.9756 12.8615 12.9831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_4575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.207fd1a03d706b89da2fbbd0faf0ba95.svg";
export { ForwardRef as ReactComponent };